import * as Sentry from "@sentry/core";
import { proxy, subscribe } from "valtio";
import { devtools } from "valtio/utils";

import type { Config, User } from "@/app/state/useAuthStateLoader";
import { LocalStorage } from "@/app/utils/localStorage";

export namespace authState {
  const storage = new LocalStorage("auth");

  export const auth = proxy({
    // todo[refactor](p5) remove `backend` & `frontend` sub-objects, or hide the implementation
    backend: {
      user: null as null | User,
      orgs: [],
      config: null as null | Config,
    },
    frontend: { isAdminMode: false },
  });
  devtools(auth, { name: "auth", enabled: true });

  subscribe(auth, () => {
    storage.save(auth.frontend);
  });

  subscribe(auth, () => {
    if (auth.backend.user) {
      const user = auth.backend.user;
      if (user.userHijacker) {
        Sentry.setUser({
          id: user.userHijacker.email,
          email: user.userHijacker.email,
          name: user.userHijacker.name,
          is_hijacker: true,
        });
      } else {
        const userIdentity = {
          email: user.email,
          name: user.name,
          org_id: user.org?.id,
          org_slug: user.org?.slug,
          is_assistant_mode: user.isAssistantMode,
          assistant_id: user.assistant?.id,
          assistant_email: user.assistant?.email,
        };
        Sentry.setUser(userIdentity);

        // todo[refactor](p5) move into analytics.ts, to help devs understand that this data is attached to every event
        // posthog.identify(user.email, userIdentity);
      }
      Sentry.setContext("config", auth.backend.config);
    } else {
      Sentry.setUser(null);
    }
  });
}
